module.exports = __webpack_public_path__ + "static/media/backvector.0cf9e6b4.svg";